<span class="dot" [ngClass]="class"></span>
